<script setup lang="ts">
import { Button, useBreakpoints } from '@collector/shared-ui'
import { useTeamSides } from '@desktop/views/Relation/composables'

const { changeSides } = useTeamSides()
const { breakpoints } = useBreakpoints()
</script>

<template>
  <div class="p-1">
    <Button
      class="text-neutral-light-10 bg-neutral-3 border-neutral-3 hover:[&>span]:text-neutral-dark-0 hover:bg-neutral-9 hover:border-neutral-9 flex-row-reverse px-2 font-bold"
      width="full"
      :size="breakpoints['2md'].value ? 'md' : 'xs'"
      :fontSize="breakpoints['2md'].value ? 'text-sm' : 'text-2xs'"
      icon="exchange"
      @click="changeSides"
    >
      <span>Change sides</span>
    </Button>
  </div>
</template>
